import "../../../../../../../vue@3.5.18_typescript@5.2.2/node_modules/vue/dist/vue.runtime.esm-bundler.js";
import s from "./styles/index.cssr.js";
import t from "../../../_mixins/use-style.js";
import a from "../../icon-switch-transition/src/IconSwitchTransition.js";
import { resolveSlot as i } from "../../../_utils/vue/resolve-slot.js";
import n from "../../icon/src/Icon.js";
import c from "../../icons/Clear.js";
import { defineComponent as m, h as o } from "../../../../../../../@vue_runtime-core@3.5.18/node_modules/@vue/runtime-core/dist/runtime-core.esm-bundler.js";
import { toRef as u } from "../../../../../../../@vue_reactivity@3.5.18/node_modules/@vue/reactivity/dist/reactivity.esm-bundler.js";
const x = m({
  name: "BaseClear",
  props: {
    clsPrefix: {
      type: String,
      required: !0
    },
    show: Boolean,
    onClear: Function
  },
  setup(e) {
    return t("-base-clear", s, u(e, "clsPrefix")), {
      handleMouseDown(r) {
        r.preventDefault();
      }
    };
  },
  render() {
    const {
      clsPrefix: e
    } = this;
    return o("div", {
      class: `${e}-base-clear`
    }, o(a, null, {
      default: () => {
        var r, l;
        return this.show ? o("div", {
          key: "dismiss",
          class: `${e}-base-clear__clear`,
          onClick: this.onClear,
          onMousedown: this.handleMouseDown,
          "data-clear": !0
        }, i(this.$slots.icon, () => [o(n, {
          clsPrefix: e
        }, {
          default: () => o(c, null)
        })])) : o("div", {
          key: "icon",
          class: `${e}-base-clear__placeholder`
        }, (l = (r = this.$slots).placeholder) === null || l === void 0 ? void 0 : l.call(r));
      }
    }));
  }
});
export {
  x as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/naive-ui@2.42.0_vue@3.5.18/~/naive-ui/es/_internal/clear/src/Clear.js
// module id = 888
// module chunks = 41